<template>
  <div class="selected" :style="{width:(width?width+'px':'100%')}">
    <div
      class="select-container" @click="openCtrl=!openCtrl"
      @mouseenter="mouseenter" @mouseleave="closeIconCtrl=false;"
    >
      <p v-show="(selectArr.length==0&&type==='multiple')||(!selectedObj[keyName]&&type==='single')" class="select-placeholder">{{ placeholder }}</p>
      <Icon
        v-show="!closeIconCtrl" type="ios-arrow-down"
        :class="arrowDownClass" size="12"
      />
      <Icon
        v-if="closeIconCtrl" type="ios-close-circle"
        class="clear-selected" @click.stop="clearSelected"
      />
      <!-- 多选样式 -->
      <div
        v-for="(item,index) in selectArr" v-if="type=='multiple'"
        :key="index" class="select-tag"
      >
        <span class="tag-text">{{ item[keyName] }}</span><Icon
          type="ios-close" class="ios-close"
          size="16" @click.stop="deleteItem(item.id)"
        />
      </div>
      <!-- 单选样式 -->
      <p v-if="type=='single'" class="selected-text">{{ selectedObj[keyName] }}</p>
    </div>
    <!-- 搜索框 -->
    <Input
      v-show="openCtrl && needSearch" key="placeholderInput"
      v-model="keyword" type="text"
      class="select-search" :placeholder="placeholderInput"
      @on-keyup="needSearch ? searchKeyword() : ''"
    />
    <!-- scroll列表 -->
    <div :class="selectListClass" :style="{bottom:data.length==0&&openCtrl?(needSearch?'-84px':'unset'):(needSearch?-(height+32)+'px':'unset')}">
      <Scroll
        v-if="data.length!=0" v-show="openCtrl"
        :on-reach-bottom="handleReachBottom"
        :height="height" :distance-to-edge="10"
      >
        <div
          v-for="(item, index) in data"
          :key="index" :class="[(tempIdArr.indexOf(item.id)>-1||selectedObj.id==item.id)?'list-item-active':'',
                                (tempDisabledIdArr&&tempDisabledIdArr.indexOf(item.id)>-1||tempDisabledIdArr[0]==item.id)?'list-item-disabled':'',
                                'list-item']"
          @click="(tempDisabledIdArr&&tempDisabledIdArr.indexOf(item.id)>-1||tempDisabledIdArr[0]==item.id)?'':chooseItem(item)"
        >

          <p v-if="!keyName2" style="line-height:18px;">{{ item[keyName] }}</p>
          <div v-if="keyName2">
            <p style="line-height:18px;">{{ item[keyName] }}<br />
              {{
                keyName2.indexOf('.')!==-1?
                  ( item[keyName2.split('.')[0]][keyName2.split('.')[1]] ):item[keyName2]
              }}</p>
          </div>
          <Icon type="md-checkmark" class="checked-icon" />
        </div>
      </Scroll>
      <Row v-if="data.length==0&&openCtrl" class="no-data">暂无数据</Row>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    path: {
      type: String,
      required: true
    },
    keyName: {
      type: String, // 需要渲染的字段
      required: true
    },
    keyName2: {
      type: String // 需要渲染的字段
    },
    placeholder: {
      type: String,
      default: '请选择成员组'
    },
    placeholderInput: {
      type: String,
      default: '请输入关键字搜索'
    },
    needSearch: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'single' // multiple  single 类型
    },
    height: {
      type: [Number, String],
      default: 200 // 高度
    },
    width: {
      type: Number
    },
    params: { // 除了keyword是否还有另外的参数
      type: Object
    },
    pagingMode: { // 是否分页
      type: Boolean,
      default: true
    },
    defaultObj: {
      type: [Object, Array] // 赋默认值
    },
    inputKey: { // 搜索框的key值
      type: String,
      default: 'keyword'
    },
    method: {
      type: String,
      default: 'GET'
    },
    disabledList: { // 禁用的id
      type: Array
    },
    isLoad: { // 部分功能不需要默认加载数据 isLoad 为 false 时默认不加载数据
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      openCtrl: false,
      selectArr: [], // 多选数组
      tempIdArr: [],
      tempDisabledIdArr: [],
      selectedObj: {}, // 单选对象
      keyword: '', // 关键字
      closeIconCtrl: false,
      inputScroll: {
        pageNum: 1,
        pageSize: this.config.pageSize,
        total: 0
      }, // 分页参数
      data: [], // 初始数据
      timer: 0
    }
  },
  computed: {
    arrowDownClass() {
      return [
        'arrow-down',
        {
          'arrow-down-visible': this.openCtrl
        }
      ]
    },
    selectListClass() {
      return [
        'select-list',
        {
          'select-list-open': this.openCtrl
        }
      ]
    }
  },
  watch: {
    path(newVal, oldVal) {
      this.getMemberGroupList('', true)
    },
    params: {
      deep: true,
      handler(newVal, oldVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          this.getMemberGroupList('', true)
        }
      }
    },
    defaultObj: {
      deep: true,
      immediate: true,
      handler(newVal, oldVal) {
        if (!newVal) return
        // 表单使用myselect组件时，改变表单内非myselect组件的值，会触发myselect组件defaultObj的更新！！需加下面判断来适配
        if (JSON.stringify(newVal) !== (oldVal && JSON.stringify(oldVal))) {
          this.voluation()
        }
      }
    }
  },
  created() {},
  beforeMount() {
    if (this.isLoad) {
      this.getMemberGroupList('', true)
    }
  },
  mounted() {
    document.addEventListener('click', e => {
      if (!this.$el.contains(e.target)) {
        this.openCtrl = false// 点击其他区域关闭
      }
    })
  },
  updated() {},
  methods: {
    // 请求成员组列表数据
    getMemberGroupList(keyword, flag) {
      if (flag) {
        this.inputScroll.pageNum = 1
      }
      const url = this.path
      const ajaxData = {
        current: this.inputScroll.pageNum,
        size: this.inputScroll.pageSize,
        [this.inputKey]: keyword || ''
      }
      if (this.params) {
        for (const key in this.params) {
          ajaxData[key] = this.params[key]
        }
      }
      if ((this.inputScroll.pageNum - 1) * this.inputScroll.pageSize > this.inputScroll.total) {
        return
      }
      if (this.method === 'GET') {
        this.$get(url, ajaxData).then(res => {
          if (res.code == 0) {
            this.data = flag ? res.data.records : this.data.concat(res.data.records)
            this.inputScroll.pageNum = res.data.current + 1
            this.inputScroll.total = res.data.total
          }
        })
      } else {
        this.$post(url, ajaxData).then(res => {
          if (res.code == 0) {
            this.data = flag ? res.data.records : this.data.concat(res.data.records)
            this.inputScroll.pageNum = res.data.current + 1
            this.inputScroll.total = res.data.total
          }
        })
      }
    },
    // 下拉加载数据
    handleReachBottom () {
      return new Promise(resolve => {
        this.getMemberGroupList(this.keyword, false)
        resolve()
      })
    },
    // 单个选中
    chooseItem(item) {
      if (this.type == 'multiple') {
        const index = this.tempIdArr.indexOf(item.id)
        if (index > -1) {
          this.selectArr.splice(index, 1)
          this.tempIdArr.splice(index, 1)
        } else {
          this.selectArr.push(item)
          this.tempIdArr.push(item.id)
        }
        this.$emit('getValue', this.selectArr)
      } else {
        this.selectedObj = item
        this.openCtrl = false
        this.$emit('getValue', this.selectedObj)
      }
      if (this.keyword) {
        this.keyword = ''
        // 因为关键字搜索之后需要重新加载第一页数据  不能删
        this.getMemberGroupList(this.keyword, true)
      }
    },
    // 删除单个
    deleteItem(id) {
      const index = this.tempIdArr.indexOf(id)
      this.selectArr.splice(index, 1)
      this.tempIdArr.splice(index, 1)
      this.$emit('getValue', this.selectArr)
    },
    // 清除所有
    clearSelected() {
      if (this.type == 'multiple') {
        this.tempIdArr.splice(0)
        this.selectArr.splice(0)
        this.$emit('getValue', this.selectArr)
      } else {
        this.selectedObj = {}
        this.$emit('getValue', this.selectedObj)
      }
    },
    // 搜索关键词 重新定位到第一页
    searchKeyword() {
      this.timer = new Date().getTime()
      setTimeout(() => {
        if (new Date().getTime() - this.timer >= 1000) {
          if (this.keyword) {
            this.getMemberGroupList(this.keyword, true)
          }
        }
      }, 1000)
    },
    mouseenter() {
      if (this.selectArr.length > 0 || this.selectedObj.name) {
        this.closeIconCtrl = true
      } else {
        this.closeIconCtrl = false
      }
    },
    voluation() {
      if (this.type === 'single' && this.defaultObj) {
        this.selectedObj[this.keyName] = this.defaultObj.name
        this.selectedObj.id = this.defaultObj.id
      } else if (this.type != 'single' && this.defaultObj) {
        const key = this.keyName
        this.tempIdArr = []
        this.selectArr = this.defaultObj.map(item => {
          this.tempIdArr.push(item.id)
          return { [key]: item.name, id: item.id }
        })
      }
      if (this.disabledList && this.disabledList.length > 0) {
        this.tempDisabledIdArr = this.disabledList.map(item => {
          return item
        })
      }
    }
  }
}
</script>
<style scoped lang="sass">
 @import './mySelect.scss'
</style>



// WEBPACK FOOTER //
// src/components/common/mySelect/mySelect.vue